import { render, staticRenderFns } from "./AccountBranch.vue?vue&type=template&id=18bc94c4&"
import script from "./AccountBranch.vue?vue&type=script&lang=js&"
export * from "./AccountBranch.vue?vue&type=script&lang=js&"
import style0 from "./AccountBranch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports